export const TextAreaDefault = ({
    id,
    label,
    SubLabel,
    placeholder,
    value,
    onChange,
    error,
    rows = 4
}) => {
    return (
        <div className="">
            <label
                htmlFor={id}
                className="block text-[11px] font-semibold text-slate-400 mb-1.5 uppercase"
            >
                {label} <span className="text-[9px] text-slate-500">{SubLabel}</span>
            </label>
            <textarea
                id={id}
                rows={rows}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="w-full px-4 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all"
            />
            {error && (
                <span className="text-xs text-red-600 font-medium mt-1 block">
                    {error}
                </span>
            )}
        </div>
    )
}
